import { NavigationCategory } from './NavigationTypes';


export const SERVICES_MENU: NavigationCategory[] = [
  {
    category: 'Client Services',
    links: [
      { name: 'Subscriptions', link: '/client-tiers' },
      { name: 'Create Client Profile', link: '/auth/client-registration?tier=bronze' },
      { name: 'Client Consulting', link: '/neatt' },
      { name: 'Trusted Partners', link: '/trusted-partners' }
    ]
  },
  {
    category: 'Enterprise Services',
    links: [
      { name: 'Products', link: '/enterprise-tiers' },
      { name: 'Become a Gold Subscriber', link: '/auth/subscriber-registration?tier=gold' },
      { name: 'Become Trusted Partner', link: '/trusted-partners' }
    ]
  },
    {
    category: 'Resources',
    links: [
      { name: 'Articles', link: '/resources/articles' },
      { name: 'Videos', link: '/resources/videos' },
    ]
  }
];


export const CONTACT_MENU: NavigationCategory[] = [
  {
    links: [
      { name: 'About Us', link: '/about' },
      { name: 'Contact Us', link: '/contact' },
      { name: 'Schedule Demo', link: 'https://calendly.com/jonathan-goffe-vermontconsumercredit/1-2-1-meeting-bni-professional-inquires' },
      { name: 'Business Inquiries', link: 'https://calendly.com/jonathan-goffe-vermontconsumercredit/1-2-1-meeting-bni-professional-inquires' }
    ]
  }
];


export const PHONE_NUMBER = '(802) 922-6268';


